import { useState } from "react";
import { EquiposListContainer } from "./EquiposContainer";
import { VendedoresList } from "./VendedoresList";
import { CustomTeamRequest, EquipoVentas } from "../../../../types/vendedor";
import { useDispatch, useSelector } from "react-redux";
import { changeActiveForm, EquipoDisponible, IntegranteDisponible, resetEquipoCustom, selectCurrentActiveForm, selectCurrentCustomTeam, selectEquiposDisponibles, setEquposDisponibles } from "../../../../store/equiposVentaSlice";
import { BotonSwapForm } from "./BotonSwapForm";
import { FormularioCreacionEquipos } from "./FormularioCreacionEquiposNocturnos";
import { useCreateCustomTeamMutation } from "../../../../api/vendedorApi";
import { getErrorMessage } from "../../../../utils/errorHelpers";
import { selectCurrentUserRole } from "../../../../api/auth/authSlice";

interface Props {
    equipos?: EquipoVentas[];
    equiposDisponibles?: EquipoVentas[];
}

export function EquiposNocturnos({ equiposDisponibles, equipos }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const dispatch = useDispatch();

    const anyEquiposAlready = useSelector(selectEquiposDisponibles).length > 0;
    const currentCustomTeam = useSelector(selectCurrentCustomTeam);
    const enableSaveButton = currentCustomTeam != undefined && currentCustomTeam.primerIntegrante != undefined && currentCustomTeam.segundoIntegrante != undefined;
    const currentActiveForm = useSelector(selectCurrentActiveForm);
    const userRole = useSelector(selectCurrentUserRole);

    const primerIntegrante = currentCustomTeam?.primerIntegrante;
    const segundoIntegrante = currentCustomTeam?.segundoIntegrante;

    const [createTeam, { isLoading }] = useCreateCustomTeamMutation();

    // set equipos disponibles
    if(equiposDisponibles && !anyEquiposAlready)
        dispatch(setEquposDisponibles(ParseEquiposVentasToEquiposDisponibles(equiposDisponibles)))

    const handleCreateCustomTeam = async () => {
        try {
            setErrorMessage(null);

            if(primerIntegrante == undefined || segundoIntegrante == undefined) return;

            const request: CustomTeamRequest = {
                primerIntegrante: primerIntegrante.id,
                segundoIntegrante: segundoIntegrante.id,
                tipo: "Nocturno"
            };

            await createTeam(request).unwrap();
            dispatch(changeActiveForm("Ninguno"));
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    return (
        <EquiposListContainer
            title="Equipos de ventas nocturno">

            {userRole === "Administrador" 
            ?
            <BotonSwapForm
                showForm={currentActiveForm == "Nocturno"}
                texto="Modificar equipos +"
                onClick={() => {
                    setErrorMessage(null);
                    dispatch(resetEquipoCustom());
                    dispatch(changeActiveForm(currentActiveForm == "Nocturno" ? "Ninguno" : "Nocturno"))
                }}/>
            : <div className="h-[22.5px] my-2 "></div>
            }

            {currentActiveForm == "Nocturno"
            ?
            <FormularioCreacionEquipos
                textoNuevoEquipo="Nuevo equipo nocturno"
                handleCreateCustomTeam={handleCreateCustomTeam}
                equiposDisponibles={equiposDisponibles}
                isLoading={isLoading}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                enableSaveButton={enableSaveButton}
                primerIntegrante={primerIntegrante}
                segundoIntegrante={segundoIntegrante}/>
            :
            <VendedoresList
                equipos={equipos} />
            }
        </EquiposListContainer>
    )
}


export function ParseEquiposVentasToEquiposDisponibles(equiposDisponibles: EquipoVentas[]): EquipoDisponible[] {
const equiposRestantes: EquipoDisponible[] = equiposDisponibles.map((equipo, index) => {
            const primerIntegrante: IntegranteDisponible = {
                id: equipo.primerIntegrante.id,
                nombre: equipo.primerIntegrante.nombre,
                disponible: true,
                tipo: equipo.primerIntegrante.tipo,
                equipoIndex: index,
            };

            const segundoIntegrante: IntegranteDisponible | undefined = equipo.segundoIntegrante ? {
                id: equipo.segundoIntegrante.id,
                nombre: equipo.segundoIntegrante.nombre,
                disponible: true,
                tipo: equipo.segundoIntegrante.tipo,
                equipoIndex: index,
            } : undefined;

            const equipoDisponible: EquipoDisponible = {
                identificador: equipo.identificador,
                primerIntegrante,
                segundoIntegrante,
            } ;
            return equipoDisponible;
        })
    return equiposRestantes;
}
